import UserDetails from 'pages/Placement/DemandDetailsMaster/Components/UserDetails';
import {
    FETCH_USER_SEARCH_LIST,
    FETCH_USER_DETAILS,
    CREATE_USER,
    UPDATE_USER_DETAILS,
    UPDATE_USER_ROLES,
} from './permissions.actions';
import { SUCCESS, FAILURE, REQUEST } from 'utils/actionGenerator';

const defaultState = {
    userSearchList: null,
    userDetails: {},
    updatedUserCode: null,
}

export default function (state = defaultState, action: any) {
    switch (action?.type) {
        case FETCH_USER_SEARCH_LIST[REQUEST] : {
            return {
                ...state,
                userSearchList: null
            }
        }
        case FETCH_USER_SEARCH_LIST[SUCCESS] : {
            return {
                ...state,
                userSearchList: action.response.data.user,
            }
        }
        case FETCH_USER_SEARCH_LIST[FAILURE] : {
            return {
                ...state,
                userSearchList: null
            }
        }

        
        case FETCH_USER_DETAILS[REQUEST] : {
            return {
                ...state,
                userDetails: {}
            }
        }
        case FETCH_USER_DETAILS[SUCCESS] : {
            return {
                ...state,
                userDetails: action.response.data
            }
        }
        case FETCH_USER_DETAILS[FAILURE] : {
            return {
                ...state,
                userDetails: {}
            }
        }
        
        case UPDATE_USER_DETAILS[REQUEST] : {
            return {
                ...state,
                updatedUserCode: null
            }
        }
        case UPDATE_USER_DETAILS[SUCCESS] : {
            return {
                ...state,
                updatedUserCode: action?.response?.data?.code
            }
        }
        case UPDATE_USER_DETAILS[FAILURE] : {
            return {
                ...state,
                updatedUserCode: null
            }
        }

        
        case UPDATE_USER_ROLES[REQUEST] : {
            return {
                ...state,
            }
        }
        case UPDATE_USER_ROLES[SUCCESS] : {
            return {
                ...state,
                userDetails : {...state.userDetails, roles: action.response.data.roleDTOs}
            }
        }
        case UPDATE_USER_ROLES[FAILURE] : {
            return {
                ...state,
            }
        }

        default: 
            return {
                ...state
            }
    }
}